import { loadStripe } from "@stripe/stripe-js";

export function getStripeInstance() {
  if (!process.env.REACT_APP_STRIPE_PUBLIC_KEY) {
    throw new Error("Variable REACT_APP_STRIPE_PUBLIC_KEY not set!");
  }

  return loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY!);
}
